import { IDjangoApi1License } from '../../tn.common';

export function hasAnyOfLicenseType(
    licenses: IDjangoApi1License[],
    licenseType: string
): boolean {
    const type =
        licenseType === 'Application' ? 'app' : licenseType.toLowerCase();
    return licenses.some((license) => {
        return license.fontRights[type] && license.fontRights[type].qty;
    });
}
